// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a.nav[data-v-68b6e0b0]{color:inherit!important;text-decoration:none}", "",{"version":3,"sources":["webpack://./resources/js/layouts/Home.vue"],"names":[],"mappings":"AACA,uBAEE,uBAAA,CADA,oBACF","sourcesContent":["\na.nav {\n  text-decoration: none;\n  color: inherit !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
